import { lazy } from "react";

const PaymentErrorCallback = lazy(() => import("shared/features/QueuePaymenrt/payment/PaymentErrorCallback"));
const PaymentSuccessCallback = lazy(() => import("shared/features/QueuePaymenrt/payment/PaymentSuccessCallback"));

const paymentRoutes = [
    { path: '/payment/success/:type?/:id?', exact: true, component: PaymentSuccessCallback },
    { path: '/payment/error/:type?/:id?', exact: true, component: PaymentErrorCallback },
];

export default paymentRoutes;   import { lazy } from "react";

const PaymentErrorCallback = lazy(() => import("shared/features/QueuePaymenrt/payment/PaymentErrorCallback"));
const PaymentSuccessCallback = lazy(() => import("shared/features/QueuePaymenrt/payment/PaymentSuccessCallback"));

const paymentRoutes = [
    { path: '/payment/success/:type?/:id?', exact: true, component: PaymentSuccessCallback },
    { path: '/payment/error/:type?/:id?', exact: true, component: PaymentErrorCallback },
];

export default paymentRoutes;   